import ajaxRequest from './ajax'
import qs from "qs"

//上传占位符
export const create_media_video_upload = params => {
  return ajaxRequest.post("media/create_media_video_upload", params)
}
//上传附件
export const upload_media = (params, body) => {
  return ajaxRequest.post("media/upload_media?" + qs.stringify(params), body)//, { responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } }
}

//获取播放的 auth
export const get_video_auth = params => {
  return ajaxRequest.get("media/get_video_auth?"+ qs.stringify(params))
}
// 删除视频与文档的关联
export const delete_media_mapping = params => {
  return ajaxRequest.post("media/delete_media_mapping?"+ qs.stringify(params))
}
//
export const upload_multi_images = (params, body) => {
  return ajaxRequest.post("media/upload_multi_images?" + qs.stringify(params), body)//, { responseType: 'blob', headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } }
}



// WEBPACK FOOTER //
// ./src/api/media.js